/* eslint-disable security/detect-object-injection */
import React, { useCallback,useState,useMemo } from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import { messages } from 'gw-capability-policychange-common-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { PremierConstants } from 'premier-constant-service';
import { useSkipStep, useContactPhoneUtil } from 'premier-capability-hooks';
import { AdditionalInterestComponent } from 'premier-capability-policyjob-react';
import wizardConfig from "premier-capability-policychange-premierSL-react/config/PremierSL-policychange-wizard-config.json5";
import presentationMetadata from './SLPolicyChangesPage.metadata.json5';
import styles from './SLPolicyChangesPage.module.scss';
import './SLPolicyChangesPage.messages';

function SLPolicyChangesPage(props) {

    const { updateWizardData, 
        wizardData: policyChangeVM, 
        currentStep, changeNextSteps } = props;

    const { steps:constantSteps } = wizardConfig;
    const [isLocationChecked, setIsLocationChecked] = useState(false);
    const [isOfferingChecked, setIsOfferingChecked] = useState(false);
    const { 
        stepProps: {
            displayAddressFields = false
        }
    } = currentStep;
    const { pageKey } = currentStep;
    const metadata = presentationMetadata[pageKey];
    const { authHeader } = useAuthentication();
    const { EndorsementService } = useDependencies('EndorsementService');
    const {
        isComponentValid,
        onValidate,
        registerInitialComponentValidation
    } = useValidation('SLPolicyChangesPage');


    useSkipStep(registerInitialComponentValidation, policyChangeVM);
    
    const { lineName } = PremierConstants;
    const productCode = _.get(policyChangeVM.value, 'baseData.productCode');
    const lobLineName = productCode ? lineName[productCode] : '';


    const selectedOffCode = _.get(policyChangeVM.value, `lobData.${lobLineName}.selectedOffering_Ext`);


    // eslint-disable-next-line arrow-body-style, react-hooks/exhaustive-deps
    const profSteps = () => {
        return _.filter(constantSteps, (step) => !step.id.includes('off') || step.id.includes(selectedOffCode));
    }

    useContactPhoneUtil(policyChangeVM);

    const selectLocation = useCallback(() => {
        setIsLocationChecked(!isLocationChecked);
        updateWizardData(policyChangeVM);
    }, [isLocationChecked, policyChangeVM, updateWizardData]);

    const selectOffering = useCallback(() => {
        setIsOfferingChecked(!isOfferingChecked);
        updateWizardData(policyChangeVM);
    }, [isOfferingChecked, policyChangeVM, updateWizardData]);


    const restructureSteps = useCallback(() => {
        
        const { currentStepIndex } = props;

        const newSteps = constantSteps.slice(currentStepIndex + 1, constantSteps.length);


        changeNextSteps(newSteps);
    }, [props, constantSteps, changeNextSteps]);

   
    // eslint-disable-next-line arrow-body-style
    const getOfferingType = useMemo(() => {
        return _.get(policyChangeVM.value, `lobData.${lobLineName}.offerings_Ext`).filter(e=>e.branchCode=== _.get(policyChangeVM.value, `lobData.${lobLineName}.selectedOffering_Ext`))[0]?.branchName
    },[lobLineName, policyChangeVM]);

    const onNext = useCallback(async () => {
        changeNextSteps(profSteps);
        restructureSteps();
        _.set(policyChangeVM, 'baseData.isTransactionSaved_Ext.value', true );
       
        policyChangeVM.value = await EndorsementService.saveEndorsement(
            [policyChangeVM.value],
            authHeader
        );
       
        return policyChangeVM;
                
    }, [changeNextSteps, profSteps, restructureSteps, policyChangeVM, EndorsementService, authHeader]);

    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top'
            }
        },
        additionalInterest: {
            value: policyChangeVM,
            path: 'baseData.additionalNamedInsureds_Ext',
            type: 'additionalInsured',
            onValueChange: updateWizardData,
            authHeader
        },
        effectiveDate: {
            minDate: _.get(policyChangeVM, 'baseData.minimumEffectiveDate.value'),
            maxDate: _.get(policyChangeVM, 'baseData.periodEndDate.value')
        },
        addressContainer: {
            visible: displayAddressFields
        },
        baseState: {
            visible: false
        },
        offeringType:{
           value: getOfferingType
        },
        locationCheckbox: {
            value: isLocationChecked,
            onValueChange: selectLocation
       },
       offeringCheckbox: {
        value: isOfferingChecked,
        label: getOfferingType,
        onValueChange: selectOffering
       }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            additionalInterestComponent: AdditionalInterestComponent,
        }
    };

    const cancelLabel = appConfig.persona === 'policyholder' ? messages.cancelAllChanges : messages.cancel;

    const shouldPageSkip = useCallback(() => {
        const status = _.get(policyChangeVM, 'baseData.periodStatus.value.code');

        return status === 'Quoted';
    }, [policyChangeVM]);

    return (
        <WizardPage
            onNext={onNext}
            skipWhen={shouldPageSkip}
            disableNext={!isComponentValid }
            showPrevious={false}
            cancelLabel={cancelLabel}
        >
            <ViewModelForm
                uiProps={metadata.content}
                model={policyChangeVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

SLPolicyChangesPage.propTypes = wizardProps;
export default SLPolicyChangesPage;